import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { take9j4462mea726 as take } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  LocalDate31mqn6zavbpi8 as LocalDate,
  Companion_getInstance3h03aipe2gus4 as Companion_getInstance,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set3ct43wkzm94lj as set,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { NativeElementWithAction32yo3q41a36ui as NativeElementWithAction } from '../InteractiveElement.mjs';
import { KeyCodes_instance1xpu3tad1ataj as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { Align_Start_getInstance48vaevgl3nrq as Align_Start_getInstance } from '../../models/data.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../models/data.commonHtml.mjs';
import {
  localDateDriverValue3efkpkqdsaql8 as localDateDriverValue,
  localDateDriverActions33yza345d5yyl as localDateDriverActions,
  localDateTimeDriverValue1ntgd6qo3p0r9 as localDateTimeDriverValue,
  localDateTimeDriverActions1tze8b198n078 as localDateTimeDriverActions,
  localTimeDriverValue1180sc3utfw98 as localTimeDriverValue,
  localTimeDriverActions21xcjktq9vd0v as localTimeDriverActions,
} from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  LocalDateTime3vqv9moe7clf4 as LocalDateTime,
  Companion_getInstance29buwn7hkq75x as Companion_getInstance_0,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import {
  LocalTime22kisvxz6f9p4 as LocalTime,
  Companion_getInstance3qlladteis94 as Companion_getInstance_1,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.charCount_1 = 10;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_2() {
  return Companion_instance;
}
var LocalDateField$content$1Class;
function LocalDateField$content$1() {
  if (LocalDateField$content$1Class === VOID) {
    class $ extends BaseListenable() {
      constructor(this$0) {
        return new.target.new_com_lightningkite_kiteui_views_direct_LocalDateField__no_name_provided__414owb_k$(this$0);
      }
      static new_com_lightningkite_kiteui_views_direct_LocalDateField__no_name_provided__414owb_k$(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          };
        }
        return $this;
      }
      set_value_bj4fx7_k$(value) {
        var tmp0 = this.this$0__1.native_1.attributes_1;
        var tmp1_safe_receiver = value == null ? null : value.toString();
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var value_0 = tmp1_safe_receiver == null ? null : take(tmp1_safe_receiver, Companion_instance.charCount_1);
        tmp0.native_1.value = value_0;
      }
      set_value_v1vabv_k$(_set____db54di) {
        return this.set_value_bj4fx7_k$((_set____db54di == null ? true : _set____db54di instanceof LocalDate()) ? _set____db54di : THROW_CCE());
      }
      get_value_j01efc_k$() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.this$0__1.native_1.attributes_1.native_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (!(charSequenceLength(tmp0_safe_receiver) === 0)) {
            tmp_1 = tmp0_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp1_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp1_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_2 = Companion_getInstance().parse$default_krgov1_k$(tmp1_safe_receiver);
        }
        return tmp_2;
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue()], [1]);
    LocalDateField$content$1Class = $;
  }
  return LocalDateField$content$1Class;
}
var LocalDateFieldClass;
function LocalDateField() {
  if (LocalDateFieldClass === VOID) {
    class $ extends NativeElementWithAction() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'input';
        // Inline function 'com.lightningkite.kiteui.views.type' call
        this.native_1.attributes_1.native_1.type = 'date';
        this.native_1.classes_1.add_utx5q5_k$('editable');
        var tmp = this;
        tmp.content_1 = LocalDateField$content$1().new_com_lightningkite_kiteui_views_direct_LocalDateField__no_name_provided__414owb_k$(this);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver = this.action_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.eventsBack_1['on' + 'keyup'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keyup';
          this_0.eventsBack_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver_0 = this.action_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          };
        }
        this.align_1 = Align_Start_getInstance();
        this.textSize_1 = get_rem(1);
        this.range_1 = null;
      }
      get_driverValue_yh5neo_k$() {
        return localDateDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), localDateDriverActions(this));
      }
      set_range_xf733e_k$(value) {
        this.range_1 = value;
        var tmp;
        if (value == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0 = this.native_1.attributes_1;
          // Inline function 'com.lightningkite.kiteui.views.minString' call
          var value_0 = take(value.get_start_iypx6h_k$().toString(), Companion_instance.charCount_1);
          tmp0.native_1.min = value_0;
          var tmp0_0 = this.native_1.attributes_1;
          // Inline function 'com.lightningkite.kiteui.views.maxString' call
          var value_1 = take(value.get_endInclusive_r07xpi_k$().toString(), Companion_instance.charCount_1);
          tmp0_0.native_1.max = value_1;
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          // Inline function 'com.lightningkite.kiteui.views.minString' call
          this.native_1.attributes_1.native_1.min = null;
          // Inline function 'com.lightningkite.kiteui.views.maxString' call
          this.native_1.attributes_1.native_1.max = null;
        }
      }
    }
    initMetadataForClass($, 'LocalDateField');
    LocalDateFieldClass = $;
  }
  return LocalDateFieldClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        this.charCount_1 = 16;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
var LocalDateTimeField$content$1Class;
function LocalDateTimeField$content$1() {
  if (LocalDateTimeField$content$1Class === VOID) {
    class $ extends BaseListenable() {
      constructor(this$0) {
        return new.target.new_com_lightningkite_kiteui_views_direct_LocalDateTimeField__no_name_provided__6xthpg_k$(this$0);
      }
      static new_com_lightningkite_kiteui_views_direct_LocalDateTimeField__no_name_provided__6xthpg_k$(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          };
        }
        return $this;
      }
      set_value_gu0m60_k$(value) {
        var tmp0 = this.this$0__1.native_1.attributes_1;
        var tmp1_safe_receiver = value == null ? null : value.toString();
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var value_0 = tmp1_safe_receiver == null ? null : take(tmp1_safe_receiver, Companion_instance_0.charCount_1);
        tmp0.native_1.value = value_0;
      }
      set_value_v1vabv_k$(_set____db54di) {
        return this.set_value_gu0m60_k$((_set____db54di == null ? true : _set____db54di instanceof LocalDateTime()) ? _set____db54di : THROW_CCE());
      }
      get_value_j01efc_k$() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.this$0__1.native_1.attributes_1.native_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (!(charSequenceLength(tmp0_safe_receiver) === 0)) {
            tmp_1 = tmp0_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp1_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp1_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_2 = Companion_getInstance_0().parse$default_rpbnp3_k$(tmp1_safe_receiver);
        }
        return tmp_2;
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue()], [1]);
    LocalDateTimeField$content$1Class = $;
  }
  return LocalDateTimeField$content$1Class;
}
var LocalDateTimeFieldClass;
function LocalDateTimeField() {
  if (LocalDateTimeFieldClass === VOID) {
    class $ extends NativeElementWithAction() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'input';
        var tmp0 = this.native_1.attributes_1;
        // Inline function 'com.lightningkite.kiteui.views.type' call
        var value = 'datetime-local';
        tmp0.native_1.type = value;
        this.native_1.classes_1.add_utx5q5_k$('editable');
        var tmp = this;
        tmp.content_1 = LocalDateTimeField$content$1().new_com_lightningkite_kiteui_views_direct_LocalDateTimeField__no_name_provided__6xthpg_k$(this);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver = this.action_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.eventsBack_1['on' + 'keyup'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keyup';
          this_0.eventsBack_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver_0 = this.action_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          };
        }
        this.align_1 = Align_Start_getInstance();
        this.textSize_1 = get_rem(1);
        this.range_1 = null;
      }
      get_driverValue_yh5neo_k$() {
        return localDateTimeDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), localDateTimeDriverActions(this));
      }
    }
    initMetadataForClass($, 'LocalDateTimeField');
    LocalDateTimeFieldClass = $;
  }
  return LocalDateTimeFieldClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        this.charCount_1 = 5;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  return Companion_instance_1;
}
var LocalTimeField$content$1Class;
function LocalTimeField$content$1() {
  if (LocalTimeField$content$1Class === VOID) {
    class $ extends BaseListenable() {
      constructor(this$0) {
        return new.target.new_com_lightningkite_kiteui_views_direct_LocalTimeField__no_name_provided__wjirny_k$(this$0);
      }
      static new_com_lightningkite_kiteui_views_direct_LocalTimeField__no_name_provided__wjirny_k$(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          };
        }
        return $this;
      }
      set_value_ps8mfa_k$(value) {
        var tmp0 = this.this$0__1.native_1.attributes_1;
        var tmp1_safe_receiver = value == null ? null : value.toString();
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var value_0 = tmp1_safe_receiver == null ? null : take(tmp1_safe_receiver, Companion_instance_1.charCount_1);
        tmp0.native_1.value = value_0;
      }
      set_value_v1vabv_k$(_set____db54di) {
        return this.set_value_ps8mfa_k$((_set____db54di == null ? true : _set____db54di instanceof LocalTime()) ? _set____db54di : THROW_CCE());
      }
      get_value_j01efc_k$() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.this$0__1.native_1.attributes_1.native_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (!(charSequenceLength(tmp0_safe_receiver) === 0)) {
            tmp_1 = tmp0_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp1_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp1_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_2 = Companion_getInstance_1().parse$default_id2jrv_k$(tmp1_safe_receiver);
        }
        return tmp_2;
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue()], [1]);
    LocalTimeField$content$1Class = $;
  }
  return LocalTimeField$content$1Class;
}
var LocalTimeFieldClass;
function LocalTimeField() {
  if (LocalTimeFieldClass === VOID) {
    class $ extends NativeElementWithAction() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'input';
        // Inline function 'com.lightningkite.kiteui.views.type' call
        this.native_1.attributes_1.native_1.type = 'time';
        this.native_1.classes_1.add_utx5q5_k$('editable');
        var tmp = this;
        tmp.content_1 = LocalTimeField$content$1().new_com_lightningkite_kiteui_views_direct_LocalTimeField__no_name_provided__wjirny_k$(this);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver = this.action_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.eventsBack_1['on' + 'keyup'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keyup';
          this_0.eventsBack_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver_0 = this.action_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          };
        }
        this.align_1 = Align_Start_getInstance();
        this.textSize_1 = get_rem(1);
        this.range_1 = null;
      }
      get_driverValue_yh5neo_k$() {
        return localTimeDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), localTimeDriverActions(this));
      }
    }
    initMetadataForClass($, 'LocalTimeField');
    LocalTimeFieldClass = $;
  }
  return LocalTimeFieldClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  LocalDateField as LocalDateField1854369auhx0q,
  LocalDateTimeField as LocalDateTimeField29gd1oxpr4f6s,
  LocalTimeField as LocalTimeField1c574dxc0ggzd,
};
//endregion

//# sourceMappingURL=LocalDateTimeField.commonHtml.mjs.map
